export default __webpack_public_path__ + "static/media/CoinGecckoLogo.23a707f9.png";